<template>
  <div class="home">
    <div id="main-visual" class="main_visual">
      <div id="main-visual-changer">
        <div><span v-on:click="change_prev()">&#9664;</span></div
        ><div class="slide-photos-area">
          <img src="../assets/img/index/main-visual/1.jpg" v-on:click="change_image(0)" class="main-select-visual"
          ><img src="../assets/img/index/main-visual/2.jpg" v-on:click="change_image(1)"
          ><img src="../assets/img/index/main-visual/3.jpg" v-on:click="change_image(2)"
          ><img src="../assets/img/index/main-visual/4.jpg" v-on:click="change_image(3)"
          ><img src="../assets/img/index/main-visual/5.jpg" v-on:click="change_image(4)"
          ><img src="../assets/img/index/main-visual/6.jpg" v-on:click="change_image(5)"
          ><img src="../assets/img/index/main-visual/7.jpg" v-on:click="change_image(6)"
          >
        </div><div style="text-align: right"><span v-on:click="change_next()">&#9654;</span></div>
      </div>
    </div>
    <div id="sm-main-visual">
      <img src="../assets/img/index/main-visual/sm/1.jpg" v-on:click="change_image(0)">
      <img src="../assets/img/index/main-visual/sm/2.jpg" v-on:click="change_image(1)">
      <img src="../assets/img/index/main-visual/sm/3.jpg" v-on:click="change_image(2)">
      <img src="../assets/img/index/main-visual/sm/4.jpg" v-on:click="change_image(3)">
      <img src="../assets/img/index/main-visual/sm/5.jpg" v-on:click="change_image(4)">
      <img src="../assets/img/index/main-visual/sm/6.jpg" v-on:click="change_image(5)">
      <img src="../assets/img/index/main-visual/sm/7.jpg" v-on:click="change_image(6)">
    </div>

    <div id="greeting-area">
      <h2>ご挨拶</h2>
      <p>
        株式会社Ｔ．Ｍカンパニーのホームページにお越しいただき、誠にありがとうございます。弊社は、愛知県の美浜町を拠点に鳶工事全般を手掛けております。<br>
        安全第一を最優先に創業より培った信頼と技術で、これまで以上にお客様に満足をして頂けますよう、全社員一丸となって努力していく所存で御座います。<br>
        今後とも皆様の一層のご支援、ご鞭撻を賜りますようお願い申し上げます。
      </p>
    </div>

    <div id="company-sns-area">
      <h2>TM Company公式SNSはじめました！</h2>
      <div id="company-sns-box">
        <a href="https://twitter.com/t_mcompany1005" target="_blank">
          <img src="../assets/img/index/sns/twitter.jpg" alt="Twitter">
        </a>
        <a href="https://www.instagram.com/t.mcompany1005/" target="_blank">
          <img src="../assets/img/index/sns/instagram.jpg" alt="Instagram">
        </a>
        <a href="https://www.tiktok.com/@t_mcompany1005" target="_blank">
          <img src="../assets/img/index/sns/tiktok.jpg" alt="TikTok">
        </a>
      </div>
    </div>

    <div id="company-profile-area">
      <h2>Company Profile</h2>
      <div id="company-profile-box">
        <h3>企業情報</h3>

        <div id="company-profile-intro">
          <div id="intro-area">
            <div id="intro-box">
              <h4>
                街づくりを支える<br>
                会社を目指して
              </h4>
              <p>
                会社の基本情報を掲載しています。<br>
                まずはT.Mカンパニーについて<br>
                紹介させていただきます。
              </p>
            </div>
            <span v-on:click="pageJump('/about')" class="intro-area-button">
              詳しくはこちら⇒
            </span>
          </div>
          <div id="intro-slide-area" class="loopAnime">
            <div id="intro-slide-bar">
              <div>
                <img src="../assets/img/index/slide/1.jpg"><img src="../assets/img/index/slide/2.jpg"><img src="../assets/img/index/slide/3.jpg"><img src="../assets/img/index/slide/4.jpg"><img src="../assets/img/index/slide/5.jpg"><img src="../assets/img/index/slide/6.jpg">
              </div><div>
              <img src="../assets/img/index/slide/1.jpg"><img src="../assets/img/index/slide/2.jpg"><img src="../assets/img/index/slide/3.jpg"><img src="../assets/img/index/slide/4.jpg"><img src="../assets/img/index/slide/5.jpg"><img src="../assets/img/index/slide/6.jpg">
            </div>
            </div>
          </div>
        </div>

        <div id="business-area-area">
          <h4>Business area</h4>
          <p class="business-area-subtitle">業務対応エリア</p>

          <p class="business-area-description">
            株式会社T.Mカンパニーは知多半島を中心として東海一円どこでも<br>
            対応が可能です。その他の地域のお客様も可能な限り対応させて<br>
            いただきますので、まずはお気軽にご相談ください。<br>
            <br>
            ※電話受付時間 月～土 8:00~18:00 / 日曜定休日
          </p>

          <a  v-on:click="pageJump('/form')" class="business-area-button"></a>
        </div>
      </div>
    </div>

    <div id="about-pages">
      <div id="about-business-content" class="rightAnime">
        <span v-on:click="pageJump('/content')">業務内容について</span>
      </div><div id="about-achievement" class="leftAnime">
      <span v-on:click="pageJump('/achievement')">施工実績について</span>
    </div>
    </div><div id="recruit-area">
    <div id="recruit-area-title" class="rightAnime">
      <h2>Recruit</h2>
      <p>採用情報</p>
    </div>
    <div id="recruit-area-list" class="leftAnime">
      <img id="tm-sqicon" src="../assets/img/index/tm-sqicon.png">
      <ul>
        <li>鳶の仕事に興味がある方。</li>
        <li>仕事にやりがいを求めている方。</li>
        <li>未経験でもこれから頑張ろうと思っている方。</li>
      </ul>
      <p>
        T.Mカンパニーの仲間たちと共に<br>
        楽しくお仕事をしましょう！！
      </p>
      <span v-on:click="pageJump('/recruit')" class="recruit-area-button"></span>
    </div>
  </div>
  </div>
</template>

<script>
  const _isSmartphone = window.matchMedia('(max-width: 749px)').matches;

  export default {
    name: 'Home',
    title: 'ホーム',
    data: function(){
      return{
        cursor: 0,
        autochange_handler : '',
        interval_time : 6000,
        mainvisual_list : [],
        images: [],
      }
    },
    methods: {
      change_next () {
        // 次の画像に切り替え
        // カーソル切替
        if(this.cursor === this.mainvisual_list.length - 1){
          this.cursor = 0;
        }else{
          this.cursor++;
        }
        // 画像の切り替え
        this.set_mainvisual();
      },
      change_prev () {          // 前の画像に切り替え
        // カーソル切替
        if(this.cursor === 0){
          this.cursor =　this.mainvisual_list.length - 1;
        }else{
          this.cursor--;
        }
        // 画像の切り替え
        this.set_mainvisual();
      },
      change_image (image_num){  // 指定番号に切り替え
        // カーソル切替
        this.cursor = (this.cursor + image_num) % 7;
        // 画像の切り替え
        this.set_mainvisual();
      },
      set_mainvisual () {        // 切替処理
        // 自動切換えを停止
        clearInterval(this.autochange_handler);
        // 画像の切り替え
        document.getElementById("main-visual").style.backgroundImage =
                'url("' + this.mainvisual_list[this.cursor] + '")';
        // 画像の並び順変更
        this.change_image_order()
        // 自動切換えを再設定
        this.autochange_handler = setTimeout(
                this.change_next,
                this.interval_time
        );
      },
      change_image_order () {
        let cursor = this.cursor
        for (let i = 0; i < this.mainvisual_list.length; i++) {
          document.getElementById("main-visual").getElementsByTagName('img')[i].src = this.mainvisual_list[cursor]
          cursor++
          if (cursor >= this.mainvisual_list.length) {
            cursor = 0
          }
        }
      },
    },
    mounted () {
      // 画像の自動切換え
      this.autochange_handler = setTimeout(
              this.change_next,
              this.interval_time
      );

      // 画像一覧を格納
      let mainvisual_list = []
      if (_isSmartphone) {
        for (let image of document.getElementById("sm-main-visual").getElementsByTagName('img')) {
          mainvisual_list.push(image.src)
        }
      }
      else{
        for (let image of this.mainvisual_list = document.getElementById("main-visual-changer").getElementsByTagName('img')) {
          mainvisual_list.push(image.src)
        }
      }
      this.mainvisual_list = mainvisual_list
    },
    updated: function () {
    }
  }
</script>

<style scoped>
  @import "../assets/css/index.css";
</style>
